import { h } from 'preact';
import StockInfoTable from '../stock-info-table';
import style from './style';

const MarketIndicators = () => (
	<div class={style['market-indicators']}>
		<StockInfoTable
			showChart
			columns={['symbol', 'price', 'change']}
			symbols={['$DJI', '$COMP', '$NYA']}
			cursor={0}
		/>
	</div>
);

export default MarketIndicators;
